import { asyncRoutes, constantRouterMap } from '@/router'

/**
 * 使用meta.role确定当前用户是否具有权限
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {

  if (route.meta && route.meta.id) {

    let itemRoutes = []
    let routes

    roles.forEach(role => {
      if(role.id == route.meta.id) {

        role.children.forEach(item => {
          
          route.children.forEach(rout => {

            if(item.id == rout.meta.id) {

              rout.meta.role = item.role

              itemRoutes.push(rout)

              routes = route

            }

          })

        })
        routes.children.splice(0, routes.children.length)

        itemRoutes.forEach(item => {
          routes.children.push(item)
        })
      }
    })

    return routes
  }
}

/**
 * 过滤异步路由表
 * @param routes --asyncRoutes
 * @param roles --权限
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    const routes = hasPermission(roles, tmp)
    
    if(routes) res.push(routes)
  })

  return res
}

const promission = {
  state: {
    routes: [],
    addRoutes: []
  },
  
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      if(routes[0].meta.id == 1) {
        constantRouterMap[2].children[0].meta.role = routes[0].children[0].meta.role
        if(constantRouterMap[2].children[0].meta.role.length) {
          constantRouterMap[2].children[0].hidden = false
        }
        routes.splice(0, 1)
      }else {
        constantRouterMap[2].hidden = true
      }

      state.routes = constantRouterMap.concat(routes)

    }
  },
  
  actions: {
    generateRoutes({ commit }, roles) {
  
      return new Promise(resolve => {
        let accessedRoutes
        if (roles === 'admin') {
          accessedRoutes = asyncRoutes || []
        } else {
          accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
        }
        commit('SET_ROUTES', accessedRoutes)

        resolve(accessedRoutes)
      })
    }
  }
}

export default promission



// WEBPACK FOOTER //
// ./src/store/modules/promission.js